import { render, staticRenderFns } from "./InProgressSubjects.vue?vue&type=template&id=4539d1c8&scoped=true"
import script from "./InProgressSubjects.vue?vue&type=script&lang=js"
export * from "./InProgressSubjects.vue?vue&type=script&lang=js"
import style0 from "./InProgressSubjects.vue?vue&type=style&index=0&id=4539d1c8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4539d1c8",
  null
  
)

export default component.exports